module.exports = __webpack_public_path__ + "static/media/sample_code.a494efc9.png";